<template>
  <div class="item" >
    <router-link class="avatar" :to="link"><img :src="data.avatar+'?imageView2/0/w/800'"></router-link>
    <h3>{{data.name}}</h3>
    <h4>{{data.company}}</h4>
    <h4>{{data.position}}</h4>
  </div>
</template>

<script>
export default {
  props: [
    'data'
  ],
  data () {
    return {
    }
  },
  computed: {
    link () {
      switch (this.data.typeId) {
        case 1:
          return `/speaker/${this.data.id}`
        case 3:
          return this.data.topicId ? `/track/${this.data.topicId}` : ''
        case 2:
          return this.data.lectureId ? `/presentation/${this.data.lectureId}` : ''
        case 4:
          return this.data.lectureIds && this.data.lectureIds.length === 1 ? `/presentation/${this.data.lectureIds[0]}` : `/speaker/${this.data.id}`
        case 6:
          return this.data.lectureIds && this.data.lectureIds.length === 1 ? `/training/${this.data.lectureIds[0]}` : `/speaker/${this.data.id}`
        default:
          return `/speaker/${this.data.id}`
      }
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
.item
  text-align: center
  .avatar
    display: block
    border-radius: 50%
    width: 70%
    height: 144px
    margin: 0 auto
    cursor: pointer
    transition: all $speed
    background-color: #fff
    border: 1px solid $grey-lighter
    +mobile
      height: auto
    &:hover
      box-shadow: 0 0 1px $grey-light, 0 0 28px $grey-light
    img
      width: 100%
      height: 100%
      border-radius: 50%
      display: block
      padding: 5px
  h3
    margin-top: 21px
    margin-bottom: 14px
    font-size: 18px
    font-weight: 600
    color: var(--primary-color)
    +mobile
      margin-top: 10px
      margin-bottom: 4px
  h4
    font-size: 13px
    line-height: 1.45em
    color: $grey
.item.dark
  h3
    color: $white
  h4
    color: $white-ter
  .avatar
    border: none
    background-color: rgba(255,255,255,.8)
    &:hover
      background-color: $white
      box-shadow: 0 0 1px $white-ter, 0 0 28px rgba(255,255,255,.3)

</style>
